import { Link } from '@remix-run/react'
import { Card, CardContent } from '~/components/ui/card'
import { cn } from '~/lib/utils'
import { getRegionUrlPrefix } from '~/lib/helpers/slugHelper'
import ReadMore from './ReadMore'

const BlogCard = ({ article, className, country }: any) => {

  const sanitizedContent = article?.blogContent
    ?.replace(/<[^>]*>/g, ' ')
    ?.replace(/\s+/g, ' ')
    ?.trim();

  return (
    <Card className={cn("relative w-full flex-shrink-0 rounded-xl shadow-custom h-full flex flex-col group hover:shadow-lg transition", className)}>
      <img
        src={`https://ik.imagekit.io/officehub/tr:h-480,fo-auto,f-avif/${article.image}`}
        alt={article.title}
        title={article.bannerImageAltText}
        width={300}
        height={160}
        className="w-full h-40 object-cover rounded-t-xl"
        loading="lazy"
        decoding="async"
      />
      <CardContent className="p-4 flex flex-col flex-1">
        <h3 className="text-sm text-gray-900 font-semibold min-h-[2.5rem] line-clamp-2">
          <Link
            to={`${getRegionUrlPrefix(article?.country || country)}/blog/${article.slug}`}
            className="after:absolute after:inset-0 after:z-[1]"
          >
            {article.title}
          </Link>
        </h3>
        <div className="flex-1">
          <ReadMore
            className="text-xs font-normal mt-2 text-gray-700 line-clamp-3"
            characters={140}
          >
            {sanitizedContent}
          </ReadMore>
        </div>
        <div className='flex justify-between text-gray-500 text-xs mt-auto pt-4 font-normal relative z-[2]'>
          <span>{article.authorName}</span>
          <span>{article.publishDateHumanReadable}</span>
        </div>
      </CardContent>
    </Card>
  )
}

export default BlogCard
